/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TariffInfoDto } from './tariff-info-dto';
import {
    TariffInfoDtoFromJSON,
    TariffInfoDtoFromJSONTyped,
    TariffInfoDtoToJSON,
    TariffInfoDtoToJSONTyped,
} from './tariff-info-dto';
import type { RoomDtoDetailsInner } from './room-dto-details-inner';
import {
    RoomDtoDetailsInnerFromJSON,
    RoomDtoDetailsInnerFromJSONTyped,
    RoomDtoDetailsInnerToJSON,
    RoomDtoDetailsInnerToJSONTyped,
} from './room-dto-details-inner';
import type { TravelineResourceDto } from './traveline-resource-dto';
import {
    TravelineResourceDtoFromJSON,
    TravelineResourceDtoFromJSONTyped,
    TravelineResourceDtoToJSON,
    TravelineResourceDtoToJSONTyped,
} from './traveline-resource-dto';

/**
 * 
 * @export
 * @interface RoomDto
 */
export interface RoomDto {
    /**
     * Room identifier
     * @type {string}
     * @memberof RoomDto
     */
    id: string;
    /**
     * Room name
     * @type {string}
     * @memberof RoomDto
     */
    name: string;
    /**
     * Room images
     * @type {Array<TravelineResourceDto>}
     * @memberof RoomDto
     */
    images: Array<TravelineResourceDto>;
    /**
     * Room category name
     * @type {string}
     * @memberof RoomDto
     */
    categoryName: string;
    /**
     * 
     * @type {Array<RoomDtoDetailsInner>}
     * @memberof RoomDto
     */
    details: Array<RoomDtoDetailsInner>;
    /**
     * List of bed types available in the room
     * @type {Array<string>}
     * @memberof RoomDto
     */
    beds: Array<string>;
    /**
     * Строка информации о колличестве мест в номере
     * @type {string}
     * @memberof RoomDto
     */
    places: string;
    /**
     * 
     * @type {Array<TariffInfoDto>}
     * @memberof RoomDto
     */
    tariffs: Array<TariffInfoDto>;
    /**
     * Описание номера
     * @type {string}
     * @memberof RoomDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the RoomDto interface.
 */
export function instanceOfRoomDto(value: object): value is RoomDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('images' in value) || value['images'] === undefined) return false;
    if (!('categoryName' in value) || value['categoryName'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('beds' in value) || value['beds'] === undefined) return false;
    if (!('places' in value) || value['places'] === undefined) return false;
    if (!('tariffs' in value) || value['tariffs'] === undefined) return false;
    return true;
}

export function RoomDtoFromJSON(json: any): RoomDto {
    return RoomDtoFromJSONTyped(json, false);
}

export function RoomDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'images': ((json['images'] as Array<any>).map(TravelineResourceDtoFromJSON)),
        'categoryName': json['categoryName'],
        'details': ((json['details'] as Array<any>).map(RoomDtoDetailsInnerFromJSON)),
        'beds': json['beds'],
        'places': json['places'],
        'tariffs': ((json['tariffs'] as Array<any>).map(TariffInfoDtoFromJSON)),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

  export function RoomDtoToJSON(json: any): RoomDto {
      return RoomDtoToJSONTyped(json, false);
  }

  export function RoomDtoToJSONTyped(value?: RoomDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'images': ((value['images'] as Array<any>).map(TravelineResourceDtoToJSON)),
        'categoryName': value['categoryName'],
        'details': ((value['details'] as Array<any>).map(RoomDtoDetailsInnerToJSON)),
        'beds': value['beds'],
        'places': value['places'],
        'tariffs': ((value['tariffs'] as Array<any>).map(TariffInfoDtoToJSON)),
        'description': value['description'],
    };
}

